/* eslint-disable object-curly-newline */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useState } from 'react';
// import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { MdDelete } from 'react-icons/md';

import { Container, Header, Row, ButtonTest } from './styles';

import history from '~/services/history';
import api from '~/services/api';

export default function Cards() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    async function getData() {
      const { data } = await api.get('/files');

      setUsers(data);
    }

    getData();
  }, [users]);

  async function handleDelete(id) {
    try {
      await api.delete(`/files/${id}`);
      return toast.success('Imagem deletado com sucesso');
    } catch (error) {
      return toast.error(
        'Essa imagem esta vinculada a algum Modulo ou Materia.'
      );
    }
  }

  return (
    <>
      <Header>
        <ButtonTest type="submit" onClick={() => history.push('/level')}>
          <h2>Level</h2>
        </ButtonTest>
        <ButtonTest type="submit" onClick={() => history.push('/subject')}>
          <h2>Subject</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/module')}>
          <h2>Modules</h2>
        </ButtonTest>

        {/* <ButtonTest type="submit" onClick={() => history.push('/card')}>
          <h2>Cards</h2>
        </ButtonTest> */}

        <ButtonTest type="submit" onClick={() => history.push('/challenge')}>
          <h2>Challenges</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/jobs')}>
          <h2>Jobs</h2>
        </ButtonTest>

        <ButtonTest
          selected
          type="submit"
          onClick={() => history.push('/file')}
        >
          <h2>Files</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/users')}>
          <h2>Users</h2>
        </ButtonTest>
      </Header>

      <Container>
        <h1>Listagem de Imagens:</h1>
        {users.map(user => (
          <Row key={user.id}>
            <div className="title">
              <img src={user.url} alt="image_url" />
              <h3>
                #{user.id}:{' '}
                <a
                  href={`${user.url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {user.name}
                </a>
              </h3>
            </div>
            <div className="description">
              <p>{user.description}</p>
            </div>
            <div className="button">
              <button
                type="submit"
                className="row"
                onClick={() => handleDelete(user.id)}
              >
                <MdDelete size={30} color="#FF0000" />
              </button>
            </div>
          </Row>
        ))}
      </Container>
    </>
  );
}
